<div class="app-profile app-gener-list"
    [ngStyle]="{'background-color': settingsData.bg_secondary_color ? settingsData.bg_secondary_color : null,'font-family': settingsData.font_family ? settingsData.font_family : null  }"
    [style.--home-accent]="settingsData.bg_primary_color || null"
    [style.--home-accent-text]="settingsData.font_primary_color || null"
    [style.--gl-fg]="settingsData.font_secondary_color || null"
    [style.--gl-bg]="settingsData.bg_secondary_color || null">
    <div class="relative">
        <video [poster]="org_info?.channel_banner" *ngIf="performerInfo?.performer_profile_video" controls
            controlsList="nodownload" id="videoPlayer" class="video">
            <source [src]="performerInfo?.performer_profile_video">
        </video>
        <div class="default-img" *ngIf="bannerUrl" [style.background-image]="'url(' + bannerUrl + ')'"></div>
        <div class="row no-gutters justify-content-center gl-back-row" *ngIf="bannerUrl">
            <div class="col-11">
                <button type="button" class="gl-back gl-back-on-banner" (click)="goICHome()">
                    <i class="fa fa-angle-left"></i><span>Back</span>
                </button>
            </div>
        </div>
        <!-- Genre name, count and Subscribe: over the bottom of the banner, on a fade into the page colour -->
        <div class="row no-gutters justify-content-center" [ngClass]="{'gl-on-banner': bannerUrl}">
            <div class="col-11 gl-head" [style.color]="settingsData.font_secondary_color || null">
                <div class="gl-head-left">
                    <button type="button" class="gl-back" *ngIf="!bannerUrl" (click)="goICHome()">
                        <i class="fa fa-angle-left"></i><span>Back</span>
                    </button>
                    <div>
                        <h1 class="gl-title" *ngIf="genreName">{{genreName}}</h1>
                        <div class="gl-meta" *ngIf="itemCountLabel">{{itemCountLabel}}</div>
                    </div>
                </div>
                <button type="button" class="gl-subscribe" *ngIf="!settingsData.is_preview && !router.url.includes('/preview')"
                    (click)="goTO()">
                    {{(isSubscribed && userInfo && userInfo.access_token) ? 'Subscribed' : 'Subscribe' }}
                </button>
                <button type="button" class="gl-subscribe slick-disabled" *ngIf="settingsData.is_preview && router.url.includes('/preview')">
                    Subscribe
                </button>
            </div>
        </div>
    </div>

    <div class="gener-types" [ngClass]="{'gener-list': activePageDataChunk && activePageDataChunk.length != 0}">
        <div class="row no-gutters justify-content-center" *ngIf="groupsList?.length || teamsList?.length || allDivisions?.length || allSports?.length">
        <div class="col-11 filter-cards gl-filters"
            [style.--filter-accent]="settingsData.font_primary_color"
            [style.--filter-bg]="settingsData.bg_primary_color"
            [style.--filter-button-bg]="settingsData.bg_secondary_color"
            [style.--filter-button-font]="settingsData.font_secondary_color">
            <!-- Group filter -->
            <app-filter-dropdown variant="chip" *ngIf="groupsList?.length && !isGroupScoped"
                icon="fa-users" [label]="groupsLabel" [allLabel]="'All ' + groupsLabel + 's'"
                [selectedLabel]="selectedGroupName"
                [options]="groupsList | filter: groupSearchText:'name'"
                [displayFn]="groupDisplayFn"
                [searchable]="true" searchPlaceholder="Search group..."
                [searchText]="groupSearchText" (searchTextChange)="groupSearchText = $event"
                (optionSelect)="selectGroup($event)">
            </app-filter-dropdown>

            <!-- Home team filter -->
            <app-filter-dropdown variant="chip" *ngIf="teamsList?.length"
                icon="fa-shield" label="Home Team" allLabel="All Home Teams"
                [selectedLabel]="selectedHomeTeamName"
                [groupedOptions]="homeGroupGroups"
                [displayFn]="teamDisplayFn"
                [searchable]="true" searchPlaceholder="Search team..."
                [searchText]="homeTeamSearchText" (searchTextChange)="onHomeTeamSearchTextChange($event)"
                (optionSelect)="selectHomeTeam($event)">
            </app-filter-dropdown>

            <!-- Away team filter -->
            <app-filter-dropdown variant="chip" *ngIf="teamsList?.length"
                icon="fa-shield" label="Away Team" allLabel="All Away Teams"
                [selectedLabel]="selectedAwayTeamName"
                [groupedOptions]="awayGroupGroups"
                [displayFn]="teamDisplayFn"
                [searchable]="true" searchPlaceholder="Search team..."
                [searchText]="awayTeamSearchText" (searchTextChange)="onAwayTeamSearchTextChange($event)"
                (optionSelect)="selectAwayTeam($event)">
            </app-filter-dropdown>

            <!-- Division filter -->
            <app-filter-dropdown variant="chip" *ngIf="divisionOptions?.length"
                icon="fa-sitemap" label="Division" allLabel="All Divisions"
                [selectedLabel]="selectedDivisionName"
                [options]="divisionOptions"
                [displayFn]="divisionDisplayFn"
                (optionSelect)="selectDivision($event)">
            </app-filter-dropdown>

            <!-- Sport filter -->
            <app-filter-dropdown variant="chip" *ngIf="sportOptions?.length"
                icon="fa-futbol-o" label="Sport" allLabel="All Sports"
                [selectedLabel]="selectedSportName"
                [options]="sportOptions"
                [displayFn]="sportDisplayFn"
                (optionSelect)="selectSport($event)">
            </app-filter-dropdown>
        </div>
        </div>
        <div class="row w-100 no-gutters justify-content-center">

            <div [ngClass]="showAdCenter ? 'col-md-9 col-11 mt-2' : 'col-11' ">

                <div class="gener-container">
                    <ng-container *ngFor="let data of activePageDataChunk">
                        <div class="gn-card pointer" *ngIf="data.is_can_see_album" tabindex="0"
                            [matTooltip]="data?.title?.length > 25 ? data?.title : ''"
                            (click)="goToAlbum(data)" (keydown.enter)="goToAlbum(data)">
                            <div *ngIf="hasOwnThumbnail(data)" class="gn-img" [style.background-image]="'url(' + data.video_thumbnail_image + ')'"></div>
                            <div *ngIf="!hasOwnThumbnail(data)" class="gn-fallback">
                                <i class="fa" [ngClass]="getMediaType(data) === 'audio' ? 'fa-music' : 'fa-video-camera'"></i>
                            </div>
                            <span class="gn-type"><i class="fa" [ngClass]="getMediaType(data) === 'audio' ? 'fa-music' : 'fa-video-camera'"></i></span>
                            <span class="gn-play"><i class="fa fa-play"></i></span>
                            <span class="gn-title"
                                [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null}">{{data?.title}}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col-11 col-md-2 mt-2 pb-4" *ngIf="showAdCenter">
                <!-- ads start -->
                <div class="text-center pt-0 pl-0 p-20">
                    <div class="d-inline-block relative">
                        <div [innerHTML]="adVideoCenter" alt=' ' title=' ' class="adcenter text-center">
                        </div>
                        <span class="icon-bg mr-2">
                            <a class="text-center" *ngIf="!router.url.includes('/preview')"
                                [href]="selectedAdCenterData" target="_blank"
                                class="mr-2 text-white text-decoration-none">Learn more <i
                                    class="fa fa-external-link fs-9 ml-1"></i></a>
                            <a class="text-center" *ngIf="router.url.includes('/preview')"
                                class="mr-2 text-white text-decoration-none slick-disabled">Learn more <i
                                    class="fa fa-external-link fs-9 ml-1"></i></a>
                        </span>
                    </div>
                </div>
                <!-- ads end -->
            </div>

        </div>
    </div>
    <mat-paginator
        *ngIf="router.url.includes('/preview') || (activatedRoute?.snapshot && activatedRoute?.snapshot?.params && activatedRoute.snapshot.params.tag_category == 'recorded-video')"
        [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="onPageChanged($event)"
        [hidden]="dataSource.filteredData.length < 21">
    </mat-paginator>
    <mat-paginator [length]="totalCount" *ngIf="showPagination && !router.url.includes('/preview') && totalCount > 20"
        [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="getVodByTag($event)"></mat-paginator>
</div>
<button matTooltip="Subscribe" matTooltipPosition='above' [ngClass]="{'show-scroll': showScroll}" mat-button
    *ngIf="!settingsData.is_preview && !router.url.includes('/preview') && !isSubscribed"
    class="subscribe-btns scroll-to-top" (click)="goTO()" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null , 
'color': settingsData.font_primary_color ? settingsData.font_primary_color : null , 'font-size': settingsData.fs_main_title ? settingsData.fs_main_title : null ,
'font-family': settingsData.font_family ? settingsData.font_family : null  }">
    <!-- {{(isSubscribed && userInfo && userInfo.access_token) ? 'Subscribed' : 'Subscribe' }} -->
    <i class="fa fa-hand-o-up player-icon play-icon pl-0" aria-hidden="true"></i>

</button>